import styled, { keyframes, css } from 'styled-components';
import Button from '../ui/Button';

 
const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-250px);
  }
  to {
    opacity: 1;
    transform: translateY(-180px);
  }
`;

const lineGrowVertical = keyframes`
  0% {
    height: 0;
    opacity: 0;
  }
  50% {
    height: 240px;
    opacity: 1;
  }
  100% {
    height: 240px;
    opacity: 0;
  }
`;

const lineGrowHorizontal = keyframes`
  0% {
    width: 0;
    opacity: 0;
  }
  50% {
    width: 200px;
    opacity: 1;
  }
  100% {
    width: 100%;
  }
`;

 
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  padding: 0 20px;
  flex-direction: row;
 
  @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 100px;
  }
`;

const TextWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TongFeiWrapper = styled.div`
  position: relative;
  display: inline-block;
  
  @media (max-width: 1200px) {
   
    margin-bottom: 100px;
  }
`;

const StyledLine = styled.div`
  position: absolute;
  background-color: white;
  z-index: 150;

  ${(props) =>
    props.desktop &&
    css`
      left: -40px;
      top: 60px;
      width: 4px;
      height: 90%;
      animation: ${lineGrowVertical} 3s ease-out forwards;
      @media (max-width: 1200px) {
        display: none;
      }
    `}

  ${(props) =>
    props.mobile &&
    props.left &&
    css`
      position: absolute;
      bottom: 100%; 
      left: 0;
      width: 100%;
      height: 2px;
      animation: ${lineGrowHorizontal} 2s ease-out forwards;

      @media (min-width: 1201px) {
        display: none;
      }
    `}

  ${(props) =>
    props.mobile &&
    props.right &&
    css`
      position: absolute;
      top: 100%;  
      right: 0;
      width: 100%;
      height: 2px;
      animation: ${lineGrowHorizontal} 2s ease-out forwards;

      @media (min-width: 1201px) {
        display: none;
      }
    `}
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transform: translateY(-250px);
  animation: ${slideIn} 1.2s ease-out forwards;
  animation-delay: 0.3s;
  z-index: 200;

  @media (max-width: 1200px) {
    align-items: center;
  }
`;

const StyledText = styled.h1`
  text-align: left;
  z-index: 200;

  &.left-text {
    font-size: 80px;
    font-weight: 400;
    margin-top: 80px;

    @media (max-width: 1200px) {
      font-size: 50px;
      text-align: center;
      margin-top: 180px;
    }
    @media (max-width: 768px) {
      font-size: 38px;
      margin-bottom: 40px;
    }
  }

  &.right-text {
    font-size: 150px;
    font-weight: 550;
    margin-right: 8px;
    z-index: 200;

    @media (max-width: 1200px) {
      font-size: 90px;
      text-align: center;
      margin: 0px;
    }
  }

  &.tong-fei-mobile {
    @media (min-width: 1201px) {
      display: none;
    }
  }

  &.tong-fei-desktop {
    @media (max-width: 1200px) {
      display: none;
    }
  }
`;

 
function Text() {
  return (
    <Wrapper>
      <LeftColumn>
        <TextWrapper>
          <StyledLine desktop />
          <StyledText className="left-text">
            Korean-Chinese <br /> Cuisine
          </StyledText>
        </TextWrapper>

        <TongFeiWrapper>
          <StyledLine mobile left />
          <StyledText className="right-text tong-fei-mobile">
            Tong <br /> Fei
          </StyledText>
          <StyledLine mobile right />
        </TongFeiWrapper>

        <Button />
      </LeftColumn>

      <StyledText className="right-text tong-fei-desktop">
        Tong <br /> Fei
      </StyledText>
    </Wrapper>
  );
}

export default Text;
